// Tour Operators segment - island hopping, diving, boat tours, snorkeling
export const TOURS_IMAGES = {
  // Hero preserved (scuba diving background)
  hero: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=1600&q=80",
  // Jet ski couple - action & fun
  wine: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/l3gdtd4w_IMG-20260731-WA0018~2.jpg",
  // Longtail boat with tourists and karst islands
  coffee: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/atpzsryl_IMG-20260731-WA0015.jpg",
  // Collage / marketing feel for the marketing section
  bar: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/6rqj14r7_IMG-20260731-WA0012.jpg",
};

const en = {
  hero: {
    eyebrow: "For Tour Operators",
    h1a: "Every seat.",
    h1b: "Every departure.",
    p: "Island hopping, snorkel trips, diving, sunset boats, fishing charters, Ang Thong - sell your departures directly, in every language, without paying OTA commissions.",
    zero: "Zero commissions,",
    ever: "ever",
    cta: "Claim your business",
    tagline: "Live in minutes \u00b7 No commissions ever \u00b7 Cancel anytime",
  },
  chips: [
    { icon: "Ship", label: "Island hopping" },
    { icon: "Waves", label: "Snorkeling" },
    { icon: "Anchor", label: "Diving trips" },
    { icon: "Sunset", label: "Sunset cruises" },
    { icon: "Fish", label: "Fishing charters" },
    { icon: "MapPin", label: "Ang Thong Marine Park" },
    { icon: "Users", label: "Private tours" },
    { icon: "Sailboat", label: "Longtail tours" },
  ],
  benefits: {
    eyebrow: "Why andAbout",
    h2a: "Fill every departure,",
    h2b: "keep every baht.",
    p: "OTAs take 20-30% of every seat. andAbout gives you a direct booking engine on the whole island, in every language your customers speak, for a flat monthly fee.",
    items: [
      { icon: "CalendarCheck2", title: "Direct bookings, live seats", body: "Every trip shows real-time availability. Guests book from your profile, your website or your agents - all pulling from the same live inventory." },
      { icon: "Users", title: "Sales agents, one dashboard", body: "Invite unlimited agents. Each sells from your live seats, every booking is tracked back to the agent, and you see the whole board in one place." },
      { icon: "Languages", title: "Multilingual trip descriptions", body: "Upload once in English. Every itinerary, safety note and pickup point is translated into 12+ languages so every guest understands what they booked." },
      { icon: "Wallet", title: "Direct payments, no OTA cut", body: "Guests pay from their phone with a card. Stripe processes it at cost and the money lands in your account - not an intermediary's." },
    ],
  },
  audience: {
    eyebrow: "Who books you",
    h2a: "The whole island,",
    h2b: "before they land.",
    p: "Your customers decide what to do the night before or the morning of. andAbout puts your departure list in front of them the moment they search.",
    items: [
      { tag: "01", heading: "Tourists tomorrow", body: "Travelers on the island tonight, searching for tomorrow's snorkel trip or dive - they see your departures in their own language." },
      { tag: "02", heading: "Hotel guests", body: "Concierges send guests to your boat directly from andAbout - no printed brochures, no missed pickups." },
      { tag: "03", heading: "Agents on the island", body: "Local sales agents pull from your live seats, so they never oversell and every booking is attributed correctly." },
    ],
    stats: [
      { k: "48k+", v: "monthly island searches" },
      { k: "12", v: "languages, auto-translated" },
      { k: "0%", v: "commission on your bookings" },
      { k: "20 min", v: "average time to go live" },
    ],
  },
  marketing: {
    eyebrow: "Included with your subscription",
    h2a: "We put you in",
    h2b: "our marketing.",
    p: "andAbout runs campaigns across the island every day, on social and in search. As a subscriber, your best trips and new departures become part of the story we tell tourists on their first evening. You bring the boat - we bring the seats.",
  },
  steps: {
    eyebrow: "Getting started",
    h2a: "Live in minutes,",
    h2b: "not months.",
    items: [
      { n: "1", title: "Claim your business", body: "Your profile may already exist. Claim it and make it yours in minutes." },
      { n: "2", title: "Add trips & seats", body: "List every departure with itinerary, pickup, price, seat count and dates." },
      { n: "3", title: "Sell every seat", body: "Guests, hotels and agents book directly. You keep every baht - andAbout never takes a commission." },
    ],
  },
  faq: {
    eyebrow: "Questions & answers",
    h2a: "Everything you were",
    h2b: "about to ask.",
    items: [
      { q: "Do you really take zero commission?", a: "Yes. andAbout charges a flat monthly subscription and never takes a cut of your seats. Card payments are processed by Stripe, and the full processing cost is passed through from Stripe with no markup: by default, 3% is added at checkout for the customer and 2% is charged to the business." },
      { q: "How do sales agents work?", a: "Invite unlimited agents. Each has their own login and sells from your live seat inventory. Every sale is tracked back to the agent, so you know who brought which guest and pay commissions transparently." },
      { q: "What kinds of trips can I list?", a: "Island hopping, snorkel trips, diving, sunset boat cruises, fishing charters, Ang Thong Marine Park day trips, private longtail tours, seaplane tours, kayak tours - anything you run today." },
      { q: "How do guests actually book?", a: "Through the andAbout app or website. Live seats, pickup times and safety info are built in - no phone calls, no oversold trips." },
      { q: "When do I get paid?", a: "Money lands in your bank account up to 7 days after the trip departs. Guests can cancel up to 48 hours before departure for a full refund, so payout is settled once that window has passed." },
      { q: "Can we cancel anytime?", a: "Yes. Both Plus and Partner are month-to-month. Annual plans include two months free but you can still cancel renewal any time." },
    ],
  },
};
export const TOURS_TRANSLATIONS = { en, th: en, ru: en };
